if (!customElements.get('product-modal')) {
  customElements.define(
    'product-modal',
    class ProductModal extends ModalDialog {
      constructor() {
        super();
        this.currentIndex = 0;
        this.mediaItems = [];
      }

      hide() {
        super.hide();
      }

      show(opener) {
        super.show(opener);
        this.initNavigation();
        this.showActiveMedia();
      }

      initNavigation() {
        this.mediaItems = Array.from(this.querySelectorAll('[data-media-id]'));
        const prevBtn = this.querySelector('.product-media-modal__nav--prev');
        const nextBtn = this.querySelector('.product-media-modal__nav--next');

        if (prevBtn && nextBtn) {
          // Remove old listeners if they exist
          if (this._prevHandler) prevBtn.removeEventListener('click', this._prevHandler);
          if (this._nextHandler) nextBtn.removeEventListener('click', this._nextHandler);

          // Create handlers that prevent event bubbling
          this._prevHandler = (e) => {
            e.preventDefault();
            e.stopPropagation();
            this.navigateToPrevious();
          };
          this._nextHandler = (e) => {
            e.preventDefault();
            e.stopPropagation();
            this.navigateToNext();
          };

          prevBtn.addEventListener('click', this._prevHandler);
          nextBtn.addEventListener('click', this._nextHandler);
        }
      }

      showActiveMedia() {
        this.querySelectorAll(
          `[data-media-id]:not([data-media-id="${this.openedBy.getAttribute('data-media-id')}"])`
        ).forEach((element) => {
          element.classList.remove('active');
        });
        const activeMedia = this.querySelector(`[data-media-id="${this.openedBy.getAttribute('data-media-id')}"]`);
        const activeMediaTemplate = activeMedia.querySelector('template');
        const activeMediaContent = activeMediaTemplate ? activeMediaTemplate.content : null;
        activeMedia.classList.add('active');
        activeMedia.scrollIntoView();

        this.currentIndex = this.mediaItems.indexOf(activeMedia);
        this.updateCounter();

        const container = this.querySelector('[role="document"]');
        container.scrollLeft = (activeMedia.width - container.clientWidth) / 2;

        if (
          activeMedia.nodeName == 'DEFERRED-MEDIA' &&
          activeMediaContent &&
          activeMediaContent.querySelector('.js-youtube')
        )
          activeMedia.loadContent();
      }

      navigateToPrevious() {
        this.currentIndex = (this.currentIndex - 1 + this.mediaItems.length) % this.mediaItems.length;
        this.showMediaAtIndex(this.currentIndex);
      }

      navigateToNext() {
        this.currentIndex = (this.currentIndex + 1) % this.mediaItems.length;
        this.showMediaAtIndex(this.currentIndex);
      }

      showMediaAtIndex(index) {
        this.mediaItems.forEach((media) => media.classList.remove('active'));
        const targetMedia = this.mediaItems[index];
        targetMedia.classList.add('active');
        targetMedia.scrollIntoView({ behavior: 'smooth' });
        this.updateCounter();
      }

      updateCounter() {
        const currentEl = this.querySelector('.modal-counter__current');
        const totalEl = this.querySelector('.modal-counter__total');
        if (currentEl && totalEl) {
          currentEl.textContent = this.currentIndex + 1;
          totalEl.textContent = this.mediaItems.length;
        }
      }
    }
  );
}
